
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.45-.5c15.435 0 27.948 12.513 27.948 27.95S42.885 55.4 27.45 55.4C12.168 55.4-.25 43.134-.496 27.911L-.5 27.45l.004-.463C-.25 11.764 12.168-.5 27.45-.5zm0 1C12.714.5.742 12.325.504 27.004L.5 27.45l.004.445C.742 42.574 12.714 54.4 27.45 54.4c14.883 0 26.948-12.066 26.948-26.95S42.333.5 27.45.5zm-3.177 10.998c1.322 0 2.455.429 3.4 1.285l.199.19 11.16 11.158a4.502 4.502 0 01.185 6.17l-.157.168-11.232 11.435c-1.013 1.012-2.217 1.512-3.62 1.497-1.403-.015-2.595-.513-3.578-1.496-.984-.983-1.482-2.175-1.496-3.58-.014-1.308.419-2.447 1.3-3.416l.195-.205 7.374-7.373-7.374-7.115c-.983-.983-1.481-2.174-1.497-3.578-.015-1.402.483-2.61 1.497-3.624 1.01-1.01 2.226-1.516 3.644-1.516z"}})])
          )
        }
      }
    